import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { TooltipProvider } from "./components/ui/tooltip.js";

import { App } from "./platform/App.js";
import { I18nProvider } from "./platform/i18n.js";
import "./styles.css";

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <I18nProvider>
      <BrowserRouter>
        <TooltipProvider>
          <App />
        </TooltipProvider>
      </BrowserRouter>
    </I18nProvider>
  </StrictMode>,
);
